import {
  Box,
  Button,
  Drawer,
  IconButton,
  SxProps,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { filterSelector } from "redux/filters/filters.selector";
import Close from "@mui/icons-material/Close";
import IosShare from "@mui/icons-material/IosShare";
import BaggageAllowance from "./FilterTypes/BaggageAllowanceFilter";
import Stops from "./FilterTypes/StopsFilter";
import DepartureTimeFilter from "./FilterTypes/DepartureTimeFilter";
import DurationFilter from "./FilterTypes/DurationFilter";
import PreferredAirlinesFilter from "./FilterTypes/PreferredAirlinesFilter";
import ClearFiltersButton from "./FilterOptions/ClearFiltersButton";
import { useTranslations } from "hooks/useTranslations";
import TravellerTypesFilter from "./FilterTypes/TravellerTypesFilter";
import { SortSearchResults } from "../Sort/MobileSort";
import { SocialShare } from "@thekilroygroup/shared-ui";

export default function MobileFilters() {
  const filterValues: any = useSelector(filterSelector);
  const [isOpen, setIsOpen] = useState(false);
  const [currentFilter, setCurrentFilter] = useState("");
  const { translations } = useTranslations();
  const translationsFilters = translations.filters;
  const [orderedFilters, setOrderedFilters] = useState([]);
  const filterOrdering = [
    "travellerTypes",
    "baggageAllowance",
    "stops",
    "departureTime",
    "maxDurations",
    "preferredAirlines",
  ];

  useEffect(() => {
    let filterTypes = translationsFilters.filterTypes;
    const nextFilters: any = [];
    filterOrdering.forEach((filterName: string) => {
      nextFilters.push(
        filterTypes.find((filter) => filter.filter === filterName),
      );
    });
    setOrderedFilters(nextFilters);
  }, [translations]);

  const handleButtonClick = (filterName: string) => {
    setCurrentFilter(filterName);
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };

  const getFilterHeader = () => {
    const filter = translationsFilters.filterTypes.find(
      (elm) => elm.filter === currentFilter,
    );
    return filter?.title;
  };

  return (
    <Box sx={sxStyles.mobileFiltersWrapper}>
      <SocialShare
        pageTitle={translations.pageTitle}
        shareUrl={window.location.href}
        email
        copyLink
        socialShareTranslations={translations.socialShare}
      >
        <IconButton sx={sxStyles.shareButton}>
          <IosShare fontSize="small" sx={sxStyles.shareIcon} />
        </IconButton>
      </SocialShare>
      <Box sx={sxStyles.mobileFilters}>
        <SortSearchResults />
        {orderedFilters.map(
          (filter: { filter: string; title: React.ReactNode }, index: any) => {
            if (filter !== undefined) {
              const isTouched = filterValues[filter.filter].touched;
              const filterName: string = filter.filter;
              return (
                <Button
                  sx={sxStyles.filterToggleButton}
                  variant={isTouched ? "contained" : "outlined"}
                  key={`filter-${filter.title}`}
                  onClick={() => handleButtonClick(filterName)}
                >
                  <Typography variant="titleMedium" weight="bold">
                    {filter.title}
                  </Typography>
                </Button>
              );
            }
          },
        )}
        <ClearFiltersButton />
      </Box>
      <Drawer anchor="bottom" open={isOpen} onClose={handleClose}>
        <IconButton className="closeButton" onClick={handleClose}>
          <Close fontSize="medium" color="primary" />
        </IconButton>
        <Box sx={sxStyles.filterWrapper}>
          <Typography variant="h5" sx={sxStyles.filterTitle}>
            {getFilterHeader()}
          </Typography>
          {currentFilter === "travellerTypes" && <TravellerTypesFilter />}
          {currentFilter === "baggageAllowance" && <BaggageAllowance />}
          {currentFilter === "stops" && <Stops />}
          {currentFilter === "departureTime" && <DepartureTimeFilter />}
          {currentFilter === "maxDurations" && <DurationFilter />}
          {currentFilter === "preferredAirlines" && <PreferredAirlinesFilter />}
          <Button
            variant="contained"
            onClick={handleClose}
            sx={sxStyles.filterSaveButton}
            size="large"
          >
            {translationsFilters.saveButtonText}
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  mobileFiltersWrapper: {
    width: "100%",
    overflow: "auto",
    py: 1.75,
    px: 2,
    display: "flex",
  },
  mobileFilters: {
    display: "inline-flex",
    "& .MuiButton-root": {
      whiteSpace: "nowrap",
      minWidth: "initial",
      mr: 2,
      lineHeight: 1,
      boxShadow: "none!important",
    },
  },
  filterToggleButton: {
    font: "fontFamily", //
    textTransform: "capitalize",
    letterSpacing: "0",
    py: 0.5,
    px: 2,
    lineHeight: 1,
  },
  filterWrapper: {
    pt: 6,
    pb: 4,
    px: 2,
  },
  filterTitle: {
    color: "primary.main",
    mb: 3.5,
  },
  filterSaveButton: {
    mt: 5,
    width: "100%",
  },
  shareButton: {
    ml: -1,
    mr: 1,
  },
  shareIcon: { color: "primary.main", fontSize: 3 * 8 },
};
